import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { downloadCertificate } from "src/services/certificates";
import { StyledLoadingContainer, StyledTextError } from "./styles";
import { Alert, CircularProgress, Typography } from "@mui/material";

export default function CertificatesClient() {
  const { hash } = useParams<{ hash: string }>();
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchCertificate = async () => {
      if (!hash) return;

      try {
        setLoading(true);
        setError(null);

        const response = await downloadCertificate(hash);
        if (!response) {
          throw new Error("No certificate data received.");
        }

        const url = URL.createObjectURL(response.data);
        setPdfUrl(url);
      } catch (err) {
        console.error(err);
        setError("Erro ao carregar certificado.");
      } finally {
        setLoading(false);
      }
    };

    fetchCertificate();
    return () => {
      if (pdfUrl) URL.revokeObjectURL(pdfUrl);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hash]);

  if (loading) return (
    <StyledLoadingContainer>
      <CircularProgress />
      <Typography variant="body1" color="text.secondary">
        Carregando certificado…
      </Typography>
    </StyledLoadingContainer>
  );

  if (error) {
    return (
      <StyledTextError>
        <Alert
          severity="error"
          variant="filled"
          sx={{
            maxWidth: 400,
            width: "100%",
            textAlign: "center",
            fontSize: { xs: 14, sm: 16 },
            borderRadius: 2,
          }}
        >
          {error}
        </Alert>
      </StyledTextError>
    );
  }

  if (!pdfUrl) {
    return (
      <StyledTextError>
        <Alert
          severity="warning"
          variant="filled"
          sx={{
            maxWidth: 400,
            width: "100%",
            textAlign: "center",
            fontSize: { xs: 14, sm: 16 },
            borderRadius: 2,
          }}
        >
          Nenhum certificado encontrado
        </Alert>
      </StyledTextError>
    );
  }

  return (
    <div style={{ width: "100%", height: "100vh" }}>
      <iframe
        src={pdfUrl}
        title="Certificado PDF"
        width="100%"
        height="100%"
        style={{ border: "none" }}
      />
    </div>
  );
}
